export const TableColumn = {
  ACTIONS: '_______actions',
  EXPAND_BUTTON: '_______expandButton',
};

// export const FilterType = {
//   INCLUDE: 'include',
//   EXCLUDE: 'exclude',
// };
